{
  "Documents & links": "מסמכים וקישורים",
  "Upload document": "העלאת מסמך",
  "Add a link": "הוספת קישור",
  "Price lists, treatment guides, policies, and pages of your own website. We read the text out of each one and the agent answers from it. Links are re-read every week, so a change on your site reaches the agent on its own.": "מחירונים, מדריכי טיפולים, מדיניות ודפים מהאתר שלכם. אנחנו מחלצים את הטקסט מכל אחד, והסוכן עונה ממנו. קישורים נקראים מחדש כל שבוע, כך ששינוי באתר מגיע לסוכן מעצמו.",
  "Nothing uploaded yet": "עוד לא הועלה כלום",
  "Upload the document you send new customers, or add your website, and the agent stops guessing.": "העלו את המסמך שאתם שולחים ללקוחות חדשים, או הוסיפו את האתר שלכם, והסוכן יפסיק לנחש.",
  "not in use": "לא בשימוש",
  "couldn't read": "לא הצלחנו לקרוא",
  "shortened": "קוצר",
  "{n} characters": "{n} תווים",
  "read {date}": "נקרא ב-{date}",
  "Re-read": "קריאה מחדש",
  "That is more than the agent can hold at once ({max} characters). The oldest documents are read first; turn off what the agent doesn't need.": "זה יותר ממה שהסוכן יכול להחזיק בו זמנית ({max} תווים). המסמכים הראשונים נקראים קודם; כבו את מה שהסוכן לא צריך.",
  "Page address": "כתובת הדף",
  "Your website, price page, menu or FAQ. We also read the pages it links to, like services and prices.": "האתר שלכם, דף המחירים, התפריט או השאלות הנפוצות. אנחנו קוראים גם את הדפים שהוא מקשר אליהם, כמו שירותים ומחירים.",
  "Name (optional)": "שם (לא חובה)",
  "Re-read this page every week": "לקרוא את הדף הזה מחדש כל שבוע",
  "Reading…": "קורא…",
  "Add": "הוספה",
  "Edit document": "עריכת מסמך",
  "What the agent reads": "מה שהסוכן קורא",
  "Exactly this text goes to the agent. Correct anything the conversion got wrong, and delete what customers never ask about.": "הטקסט הזה בדיוק נשלח לסוכן. תקנו מה שההמרה פספסה, ומחקו מה שלקוחות לא שואלים עליו.",
  "The agent uses this": "הסוכן משתמש בזה",
  "Your edits here are replaced the next time the page is read.": "העריכות כאן יידרסו בפעם הבאה שהדף ייקרא.",
  "{name} is larger than {max}.": "{name} גדול מ-{max}.",
  "{name} added: the agent reads {n} characters.": "{name} נוסף: הסוכן קורא {n} תווים.",
  "We couldn't read that file.": "לא הצלחנו לקרוא את הקובץ.",
  "Where": "איפה",
  "In person": "פרונטלי",
  "Online (video call)": "אונליין (שיחת וידאו)",
  "By phone": "בטלפון",
  "no meeting link": "אין קישור לשיחה",
  "Where it happens": "איפה הפגישה מתקיימת",
  "Online appointments get a joining link in the confirmation the agent sends.": "לפגישות אונליין הסוכן שולח קישור הצטרפות באישור ההזמנה.",
  "Meeting link for this service": "קישור לשיחה עבור השירות הזה",
  "Optional. Leave empty to use the room of whoever takes the appointment (set under Staff & calendars), or your business default in Settings → Business.": "לא חובה. אם תשאירו ריק, נשתמש בחדר של מי שייקח את הפגישה (מוגדר תחת צוות ויומנים), או בברירת המחדל של העסק בהגדרות → העסק.",
  "Meeting room": "חדר פגישה",
  "This person's own Zoom, Teams or Meet link. The agent sends it to the customer when they book an online service.": "הקישור האישי של העובד ב-Zoom, Teams או Meet. הסוכן שולח אותו ללקוח כשהוא קובע שירות אונליין.",
  "Website": "אתר אינטרנט",
  "The agent may share it, and reads it under AI agent → Documents & links.": "הסוכן יכול לשתף אותו, והוא נקרא תחת סוכן AI → מסמכים וקישורים.",
  "Default meeting room": "חדר פגישה ברירת מחדל",
  "Your Zoom, Teams or Meet link, used for online services when a service or staff member has none of their own.": "הקישור שלכם ב-Zoom, Teams או Meet. משמש לשירותים אונליין כששירות או עובד לא הגדירו קישור משלהם.",
  "Join the meeting": "כניסה לשיחה",
  "Copy invite link": "העתקת קישור ההזמנה",
  "Invite link copied": "קישור ההזמנה הועתק",
  "customer chooses": "הלקוח בוחר",
  "The default. Online appointments get a joining link in the confirmation the agent sends.": "ברירת המחדל. בפגישות אונליין נשלח קישור הצטרפות באישור שהסוכן שולח.",
  "Customer can also choose": "הלקוח יכול לבחור גם",
  "Tick more than one way and the agent and booking page ask the customer which they prefer. The choice is saved on the booking and used in its reminders.": "סמנו יותר מאפשרות אחת, והסוכן ודף ההזמנה ישאלו את הלקוח מה נוח לו. הבחירה נשמרת בתור ומשמשת בתזכורות שלו.",
  "Phone call: call the customer": "שיחת טלפון: להתקשר ללקוח",
  "Video call": "שיחת וידאו"
}
